export default __webpack_public_path__ + "static/media/DeliveryTracker.ce358a7c.svg";